<script lang="ts">import { isMobile } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
export let title;
export let description;
export let image;
const getMobileImage = (desktopImage) => {
	const eventImageMatch = desktopImage.match(/(event-\d+)(\.[^./?]+)(\?.*)?$/);
	if (eventImageMatch) {
		const [, imageName, extension, query = ""] = eventImageMatch;
		return desktopImage.replace(/(event-\d+)(\.[^./?]+)(\?.*)?$/, `${imageName}-mobile${extension}${query}`);
	}
	const genericMatch = desktopImage.match(/(\.[^./?]+)(\?.*)?$/);
	if (genericMatch) {
		const [, extension, query = ""] = genericMatch;
		return desktopImage.replace(/(\.[^./?]+)(\?.*)?$/, `-mobile${extension}${query}`);
	}
	return `${desktopImage}-mobile`;
};
$: currentImage = $isMobile ? getMobileImage(image) : image;
</script>

<div class="vip-event-card-container">
	<InfoCard width="100%" height="100%" borderRadius="20px" noPadding>
		<div class="vip-event-card-content">
			{#if $isMobile}
				<img src={currentImage} alt={title} class="vip-event-card-image-mobile" />
				<div class="vip-event-card-content-text-mobile">
					<Text
						type="title"
						titleSize="h6"
						titleWeight="semibold"
						textAlign="start"
						customStyle="font-size: 16px;">{title}</Text
					>
					<Text type="body" bodySize="small" textAlign="start">{description}</Text>
				</div>
			{:else}
				<div class="vip-event-card-content-text">
					<Text type="title" titleSize="h6" titleWeight="semibold" textAlign="start">{title}</Text>
					<Text type="body" bodySize="large" textAlign="start">{description}</Text>
				</div>
				<img src={currentImage} alt={title} class="vip-event-card-image" />
			{/if}
		</div>
	</InfoCard>
</div>

<style>
	.vip-event-card-container {
		margin-bottom: 1.5rem;
		height: 280px;
		width: 100%
}

	.vip-event-card-content {
		position: relative;
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: flex-end;
		overflow: hidden;
		padding: 0px
}

	.vip-event-card-content-text-mobile {
		margin-top: auto;
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 0.5rem;
		padding: 1rem;
		background: linear-gradient(180deg, rgba(18, 32, 70, 0) 0%, rgba(27, 53, 105, 0.96) 28%);
		z-index: 1
}

	.vip-event-card-image-mobile {
		position: absolute;
		left: 0px;
		top: 0px;
		height: 100%;
		width: 100%;
		border-radius: 12px;
		-o-object-fit: cover;
		   object-fit: cover;
		padding: 1px;
		z-index: 0
}

	.vip-event-card-content-text {
		display: flex;
		height: 100%;
		width: 40%;
		flex-direction: column;
		justify-content: center;
		gap: 1rem;
		z-index: 1
}

	.vip-event-card-image {
		position: absolute;
		left: 0px;
		top: 0px;
		height: 100%;
		width: auto;
		border-radius: 12px;
		padding: 1px;
		z-index: 0
}

	@media (min-width: 1024px) {
		.vip-event-card-container {
				height: 300px;
				width: 49%
		}

		.vip-event-card-content {
				align-items: center;
				justify-content: flex-end;
				padding: 1rem
		}
	}
</style>
